import React from 'react';
import styled from 'styled-components';
import postal from 'postal';
import classNames from 'classnames';
import { propTypes, defaultProps } from './prop-types';
import { useIsMobile } from '../../shared/theme';
import MicroProfile from './micro-profile';
import Contributor from './mp-components/contributor';
import Expertise from './mp-components/expertise';
import Actions from './mp-components/actions';

const Profile = styled.section`
  font-size: 18px;
  position: relative;

  &.--form-expanded {
    border-radius: 0 0 4px 4px;
    box-shadow: 0 10px 20px rgba(53, 65, 76, 0.2);
    transition: box-shadow .3s ease-in;

    > .micro-profile-areas-of-expertise {
      border-radius: 0;
      border-bottom: 0;
    }
  }
`;

export default function EowCompactMobile(props) {
  const [expanded, setExpanded] = React.useState(false);
  const isMobile = useIsMobile();

  React.useEffect(() => {
    postal.subscribe({
      channel: 'micro-profile.commands',
      topic: 'present-lead-capture-form',
      callback: () => setExpanded(true),
    });
  }, []);

  if (!isMobile) {
    // This check is here to double check the server side done by:
    // `browser.device.mobile?`
    // is inline with the client mobile concept.
    return <MicroProfile {...props} />;
  }

  const { profile } = props;

  return (
    <Profile
      className={classNames('micro-profile', { '--form-expanded': expanded })}
      data-profile-id={profile.id}
      data-profile-path={`contributors/${profile.slug}`}
      data-target="wire-micro-profile"
    >
      <Contributor {...props} />
      <Expertise {...props} />
      <Actions {...props} />
    </Profile>
  );
}

EowCompactMobile.propTypes = propTypes;
EowCompactMobile.defaultProps = defaultProps;
